import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { SettingsIcon } from '@moia-dev/pace-icons'
import { UserManagementAreaRoutes } from './UserManagementAreaRoutes'

export const UserManagementAreaNavigationIcon = SettingsIcon

export const UserManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const hasUserManagementCrud = useUserHasAccess({
    allowedRights: [BoumRight.ADMIN_PANEL_USER_MANAGEMENT_CRUD],
  })

  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={
        hasUserManagementCrud
          ? UserManagementAreaRoutes.AllUsers.route
          : UserManagementAreaRoutes.Backoffice.Groups.route
      }
      Icon={SettingsIcon}
    />
  )
}
